import create from 'zustand';
import { persist } from 'zustand/middleware';

const useCompanyReportStore = create(
	persist(
		(set) => ({
			companyType: '',
			companyName: '',
			companyId: '',
			setCompanyType: (value) => set({ companyType: value || '' }),
			setCompanyName: (value) => set({ companyName: value || '' }),
			setCompanyId: (value) => set({ companyId: value || '' }),
		}),
		{ name: 'company-type-id-name' },
	),
);

export default useCompanyReportStore;
